import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import IconButton from 'components/common/IconButton';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import BuscadorSatModal from './BuscadorSatModal';

const AgregarProducto = ({ productos, renovaciones }) => {

    //const datos = productos.productos || productos; // Se asegura de que funcione en ambas estructuras*/

    const [datos, setDatos] = useState({
        idProducto: "0",
        idCatDepartamento: '',
        vCodigoBarras: "",
        vNombreProducto: "",
        dExistencia: "",
        dPrecioUnitario: "0",
        dTasaCuotaIVA: "0",
        vTipoFactorIVA: "",
        dIVA: "0",
        dTotal: "0",
        bServicio: '',
        dCreatedDate: "",
        vClaveUnidadSat: null,
        vCodigoProductoServicioSat: null,
        vImagenProducto_Base64: null,
        vImagenProducto_Name: null,
        bIsActive: '',
        iTipoPago: "",
        vTipoProducto: "",
        vMoneda: "MXN", // 🆕 Moneda por defecto
        idCatTipoLicencia: null,
        iCanalProducto: "0",
        renovaciones: [
            { tipo: 'semanal', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
            { tipo: 'mensual', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
            { tipo: 'semestral', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
            { tipo: 'anual', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
        ]
    });

    //const { register, handleSubmit, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const { token, setToken } = useToken();
    const theme = useTheme();
    const { showErrorToast, showSuccessToast } = useToast();

    const [arrastrarImagen, setArrastrarImagen] = useState(false);
    const [imagenProducto, setImagenProducto] = useState({
        file: null
    });
    const [existencia, setDExistencia] = useState('')
    const [esActivo, setEsActivo] = useState('');
    const [tasaCuotaIVA, setTasaCuotaIVA] = useState("");
    const [claveDescripcion, setClaveDescripcion] = useState("");
    const [servicio, setServicio] = useState('');
    const [validarClave, setValidarClave] = useState({});
    const [validarCodigo, setValidarCodigo] = useState({});
    const [guardando, setGuardando] = useState(false);

    const [nuevoProducto, setNuevoProducto] = useState(true);
    const [showBuscadorProducto, setShowBuscadorProducto] = useState(false);
    const [showBuscadorUnidad, setShowBuscadorUnidad] = useState(false);
    const [tiposLicencia, setTiposLicencia] = useState([]);

    useEffect(() => {

        validarProductos();
        cargarTiposLicencia();
    }, []);


    const cargarTiposLicencia = async () => {
        try {
            const response = await fetch('/api/Productos/ObtenerTiposLicencia', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Error al obtener tipos de licencia');
            }

            const data = await response.json();

            if (data.iResponseType === 1 && data.detalles) {
                // Parsear los detalles que vienen como JSON string
                const detallesData = JSON.parse(data.detalles);
                if (detallesData.table2 && detallesData.table2.length > 0) {
                    setTiposLicencia(detallesData.table2);
                }
            }
        } catch (error) {
            console.error('Error al cargar tipos de licencia:', error);
            showErrorToast('Error al cargar tipos de licencia');
        }
    };


    const validarProductos = async () => {

        console.log("Renovaciones actualizadas en AgregarProducto:", renovaciones);

        if (productos != null && productos) {

            const renovacionesDefault = [
                { tipo: 'semanal', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
                { tipo: 'mensual', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
                { tipo: 'semestral', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
                { tipo: 'anual', priceId: '', activo: false, preciounitario: '', tasacuotaiva: '', tipofactoriva: '', iva: '', total: '' },
            ];

            // Normaliza renovaciones a array si viene como objeto tipo DataTable plano
            const renovacionesArray = Array.isArray(renovaciones)
                ? renovaciones
                : Object.values(renovaciones || {});

            console.log('Renovaciones desde el backend:', renovacionesArray);
            console.log('Tipos esperados:', renovacionesDefault.map(r => r.tipo));
            console.log('Tipos obtenidos:', renovacionesArray.map(r => r.tipo));

            const renovacionesFinales = renovacionesDefault.map(r => {
                const match = renovacionesArray.find(row =>
                    row.tipo?.trim().toLowerCase() === r.tipo.trim().toLowerCase());

                return match ? {
                    tipo: match.tipo,
                    priceId: match.priceId?.toString() ?? '',
                    activo: true,
                    preciounitario: match.preciounitario?.toString() ?? '',
                    tasacuotaiva: match.tasacuotaiva?.toString() ?? '',
                    tipofactoriva: match.tipofactoriva ?? '',
                    iva: match.iva?.toString() ?? '',
                    total: match.total?.toString() ?? ''
                } : r;
            });

            // Aplica los datos al estado
            setDatos(prev => ({
                ...prev,
                ...productos,
                vMoneda: productos.vMoneda || "MXN", // 🆕 Cargar moneda del producto
                idCatTipoLicencia: productos.idCatTipoLicencia || null,
                iCanalProducto: productos.iCanalProducto?.toString() || "0",
                renovaciones: renovacionesFinales
            }));

            datos.dExistencia
            setServicio(productos.bServicio ? "1" : "0");
            setEsActivo(productos.bIsActive ? "1" : "0");
            setDExistencia(productos.bServicio === 1 ? '0' : productos.dExistencia)
            setTasaCuotaIVA(productos.dTasaCuotaIVA)
            setTasaCuotaIVA(productos.dTasaCuotaIVA)
            setImagenProducto(prevState => ({
                ...prevState,  // Mantiene todas las demás propiedades del objeto
                file: productos.vImagenProducto_Base64
            }));
            setNuevoProducto(false);

            setValidarClave({
                validadoClaveUnidad: true,
                validandoClaveUnidad: false
            });
            setValidarCodigo({
                validadoCodigoSat: true,
                validandoCodigoSat: false
            });
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setDatos({
            ...datos,
            [name]: value.toUpperCase(), // Convertir a mayúsculas
        });
    };

    // Función para actualizar el estado
    const actualizarClaveUnidad = (campo, valor) => {
        setDatos((prevState) => ({
            ...prevState,
            [campo]: valor,
        }));
        setValidarClave({
            validadoClaveUnidad: false,
            validandoClaveUnidad: false,
        });
    };

    // Función para actualizar el estado
    const actualizarCodigoProd = (campo, valor) => {
        setDatos((prevState) => ({
            ...prevState,
            [campo]: valor,
        }));

        setValidarCodigo({
            validadoCodigoSat: false,
            validandoCodigoSat: false,
        });
    };

    // Función para manejar cambios en el campo
    const tasaCuota = (e) => {
        const nuevaTasa = parseFloat(e.target.value || 0);
        setTasaCuotaIVA(nuevaTasa);

        calculaImpuestos(datos.vTipoFactorIVA, datos.dTotal, nuevaTasa); // cálculo principal

        calcularRenovacionesDesdeTasaCuota(datos.vTipoFactorIVA, nuevaTasa); // cálculo para renovaciones
    };


    const calculaImpuestos = async (TipoFactor, Total, tasaCuotaIVA) => {
        var iva = 0;
        var precioUnitario = 0;

        if (TipoFactor == "Tasa") {
            //iva = Total * tasaCuotaIVA;
            //precioUnitario = Total - iva;
            precioUnitario = Total / (1 + tasaCuotaIVA);
            iva = Total - precioUnitario;
        }

        if (TipoFactor == "Exento") {
            iva = 0;
            precioUnitario = Total;
        }

        if (TipoFactor == "Cuota") {
            iva = tasaCuotaIVA;
            precioUnitario = Total - tasaCuotaIVA;
        }

        var datos_ = datos;
        datos_.dPrecioUnitario = precioUnitario;
        datos_.dTasaCuotaIVA = iva;
        datos_.vTipoFactorIVA = TipoFactor;
        datos_.dTasaCuotaIVA = tasaCuotaIVA;
        datos_.dTotal = Total;

        //setDatos(datos_);
        setDatos({ ...datos, dIVA: iva, dPrecioUnitario: precioUnitario });
    }

    const calcularRenovacionesDesdeTasaCuota = (tipoFactor, tasaCuota) => {
        const nuevasRenovaciones = datos.renovaciones.map((r) => {
            const total = parseFloat(r.total || 0);
            if (!total || isNaN(total)) return { ...r }; // Si no hay total, no se calcula nada

            let iva = 0;
            let precioUnitario = 0;

            if (tipoFactor === "Tasa") {
                //iva = total * tasaCuota;
                //precioUnitario = total - iva;
                precioUnitario = total / (1 + tasaCuota);
                iva = total - precioUnitario;
            } else if (tipoFactor === "Exento") {
                iva = 0;
                precioUnitario = total;
            } else if (tipoFactor === "Cuota") {
                iva = tasaCuota;
                precioUnitario = total - tasaCuota;
            }

            return {
                ...r,
                tipofactoriva: tipoFactor,
                tasacuotaiva: tasaCuota,
                iva: iva.toFixed(2),
                preciounitario: precioUnitario.toFixed(2),
                total: total.toFixed(2)
            };
        });

        setDatos(prev => ({
            ...prev,
            renovaciones: nuevasRenovaciones
        }));
    };

    /**
     * Funcion para guardar un nuevo producto
     */
    const guardarProductos = async () => {

        if (datos.vClaveUnidadSat === null) {

            showErrorToast('Debes seleccionar una clave de unidad');
            return;
        }


        if (datos.vTipoProducto === "" || datos.vTipoProducto === null) {

            showErrorToast('Debes seleccionar el tipo de producto');
            return;
        }

        // Validar que si el tipo de producto es "Licencia", se haya seleccionado un tipo de licencia
        if (datos.vTipoProducto === "Licencia" && (!datos.idCatTipoLicencia || datos.idCatTipoLicencia === null)) {

            showErrorToast('Debes seleccionar un tipo de licencia');
            return;
        }


        if (datos.iTipoPago === "" || datos.iTipoPago === null) {

            showErrorToast('Debes seleccionar el tipo de pago');
            return;
        } else if (datos.iTipoPago === "2") {
            const renovacionesActivas = datos.renovaciones.filter(r => r.activo);

            if (renovacionesActivas.length === 0) {

                showErrorToast('Debes seleccionar al menos un tipo de renovación');
                return;
            }

            for (const renovacion of renovacionesActivas) {
                if (!renovacion.total || renovacion.total.toString().trim() === '') {

                    showErrorToast(`Debes ingresar el precio para la renovación ${renovacion.tipo}`);
                    return;
                }
            }
        }



        datos.vImagenProducto_Base64 = imagenProducto.file;

        if (imagenProducto.file != null) {
            datos.vImagenProducto_Name = datos.vNombreProducto;
        }

        datos.bServicio = servicio;
        datos.bIsActive = esActivo;
        datos.dExistencia = existencia;
        datos.vClave = datos.vClaveUnidadSat;
        datos.dTasaCuotaIVA = tasaCuotaIVA;
        console.log("data guardarProductos", datos)

        setGuardando(true);

        const response = await fetch("/api/Productos/GuardarProductos",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(datos)
            })
            .catch((error) => {

                setGuardando(false);
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            console.log("response (guardarProductos): ", response);
            const data = await response.json();
            console.log("data (guardarProductos2): ", data);


            if (data.iResponseType == 1) {
                // ✅ Éxito total (producto guardado + Stripe OK)
                showSuccessToast(data.vMessage);
                navigate('/productos/Catalogo')

            } else if (data.iResponseType == 3) {
                // ⚠️ Éxito con advertencias (producto guardado pero problemas con Stripe)

                // Parsear los detalles para obtener las advertencias
                let advertencias = [];
                let mensajeError = "";
                try {
                    const detalles = JSON.parse(data.detalles);
                    advertencias = detalles.advertencias || [];
                    mensajeError = detalles.mensajeError || "";
                } catch (e) {
                    console.error("Error parseando detalles:", e);
                }

                // Construir mensaje limpio y claro
                let mensajeCompleto = "PRODUCTO GUARDADO CORRECTAMENTE\n\n";
                mensajeCompleto += "ADVERTENCIA DE STRIPE:\n";
                mensajeCompleto += mensajeError + "\n";

                if (advertencias.length > 0) {
                    mensajeCompleto += advertencias.join("\n");
                }

                // Mostrar toast con estilo de advertencia
                showErrorToast(mensajeCompleto, {
                    autoClose: 12000, // 12 segundos para leer todo
                    style: {
                        backgroundColor: '#fff3cd',
                        color: '#856404',
                        border: '1px solid #ffc107',
                        whiteSpace: 'pre-line', // Respetar saltos de línea
                        padding: '15px',
                        fontSize: '14px',
                        lineHeight: '1.6'
                    }
                });

                console.warn("Advertencias de Stripe:", {
                    mensaje: mensajeError,
                    advertencias: advertencias
                });

                // Navegar al catálogo después de 2 segundos
                setTimeout(() => {
                    navigate('/productos/Catalogo');
                }, 2000);

            } else {
                // ❌ Error al guardar
                setGuardando(false);

                showErrorToast(data.vMessage);
                console.log("data_(guardarProductos error)", data.vMessage);
            }

        }
        else {
            setGuardando(false);

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";

            }
        }

    }

    // Selecciona el archivo de imagen
    const seleccionarImagen = (e) => {
        const file = e.target.files[0];

        if (file) {
            // Validar tipo de archivo
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                console.error("Formatos permitidos: JPG, PNG");

                showErrorToast("Solo se permiten archivos JPG y PNG.");
                return;
            }

            // Validar extensión del archivo (case insensitive)
            const validExtensions = ['.jpg', '.jpeg', '.png'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                console.error("Extensiones permitidas: .jpg, .jpeg, .png");

                showErrorToast("Extensión no válida. Use JPG o PNG.");
                return;
            }

            // Validar longitud del nombre del archivo
            const MAX_NAME_LENGTH = 50;
            if (file.name.length > MAX_NAME_LENGTH) {
                console.error("Nombre demasiado largo");
                showErrorToast(`El nombre no debe exceder ${MAX_NAME_LENGTH} caracteres.`);
                return;
            }

            // Validar tamaño del archivo (2 MB = 2 * 1024 * 1024 bytes)
            const MAX_FILE_SIZE = 2 * 1024 * 1024;
            if (file.size > MAX_FILE_SIZE) {
                console.error("Tamaño excedido");
                showErrorToast("El tamaño máximo permitido es 2MB.");
                return;
            }


            // Si todas las validaciones son correctas, procesar el archivo
            procesarArchivo(file, setImagenProducto);
        }
    };

    /**
    * Procesa la imagen
    */
    const procesarArchivo = (file, setArchivo) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const base64String = event.target.result.split(",")[1];
            setArchivo({
                fileName: file.name,
                file: base64String
            });
            console.log("ARCHIVO Y NOMBRE", { fileName: file.name, file: base64String }); // Para depuración
        };

        reader.onerror = () => {
            console.error("Error al leer el archivo.");
        };

        reader.readAsDataURL(file);
    };

    // Manejar arrastrar archivos
    const handleDrag = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragover" || e.type === "dragenter") {
            setArrastrarImagen(true);
        } else if (e.type === "dragleave") {
            setArrastrarImagen(false);
        }
    }, []);

    // Manejar soltar archivos
    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setArrastrarImagen(false);

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            seleccionarImagen({ target: { files } }); // Reutilizamos la misma función del input
        }
    }, [seleccionarImagen]);

    const borrarImagen = () => {
        // Limpiar el estado de la imagen
        setDatos((prevDatos) => ({
            ...prevDatos,
            vImagenProducto_Name: '', // Limpiar el nombre de la imagen
            vImagenProducto: null,    // Limpiar el archivo de la imagen
        }));

        // Limpiar el input de archivo
        const inputFile = document.getElementById('imagenProducto');
        if (inputFile) {
            inputFile.value = ''; // Restablecer el valor del input
        }

        // Si tienes un estado adicional para la imagen, también debes limpiarlo
        setImagenProducto({
            file: null
        });
    };

    const handleChangeTipoProducto = (e) => {
        const { name, value } = e.target;
        setDatos({ ...datos, [name]: value });
    };


    //Tipo Pago
    const handleChangeTipoPrecio = (e) => {
        const { name, value } = e.target;
        setDatos({ ...datos, [name]: value });
    };

    //const handleCheckboxChange = (e) => {
    //    const { name, checked } = e.target;
    //    setDatos((prev) => ({
    //        ...prev,
    //        renovaciones: {
    //            ...prev.renovaciones,
    //            [name]: checked,
    //        },
    //    }));
    //};

    const handleCheckboxChange = (tipo) => {
        setDatos((prev) => ({
            ...prev,
            renovaciones: prev.renovaciones.map((r) =>
                r.tipo === tipo ? { ...r, activo: !r.activo } : r
            ),
        }));
    };


    //const handlePrecioChange = (e) => {
    //    const { name, value } = e.target;
    //    setDatos((prev) => ({
    //        ...prev,
    //        precios: {
    //            ...prev.precios,
    //            [name]: value,
    //        },
    //    }));
    //};

    const handlePrecioChange = async (tipo, valor) => {
        const renovacionesActualizadas = [...datos.renovaciones];
        const index = renovacionesActualizadas.findIndex(r => r.tipo === tipo);

        const tipoFactor = renovacionesActualizadas[index].tipofactoriva || datos.vTipoFactorIVA || "Tasa";
        const tasaCuota = parseFloat(renovacionesActualizadas[index].tasacuotaiva || datos.dTasaCuotaIVA || "0");
        const total = parseFloat(valor) || 0;

        let iva = 0;
        let precioUnitario = 0;

        if (tipoFactor === "Tasa") {
            //iva = total * tasaCuota;
            //precioUnitario = total - iva;
            precioUnitario = total / (1 + tasaCuota);
            iva = total - precioUnitario;
        } else if (tipoFactor === "Exento") {
            iva = 0;
            precioUnitario = total;
        } else if (tipoFactor === "Cuota") {
            iva = tasaCuota;
            precioUnitario = total - tasaCuota;
        }

        renovacionesActualizadas[index] = {
            ...renovacionesActualizadas[index],
            tipofactoriva: datos.vTipoFactorIVA,
            tasacuotaiva: datos.dTasaCuotaIVA,
            total: valor,
            iva: iva.toFixed(2),
            preciounitario: precioUnitario.toFixed(2)
        };

        setDatos(prev => ({
            ...prev,
            renovaciones: renovacionesActualizadas
        }));
    };

    return (
        <>
            {nuevoProducto &&
                <Card className="mb-1 p-2">
                    <Row className="g-1 align-items-sm-center">
                        <Col xs="auto" className="d-flex align-items-center">
                            <IconButton
                                onClick={() => navigate(-1)}
                                variant="falcon-default"
                                size="sm"
                                icon="arrow-left"
                            />
                        </Col>
                        <Col xs="auto" className="d-flex align-items-center">
                            <img src="/img/ordenes96.png" alt="connectCircle" height={50} />
                        </Col>
                        <Col xs="auto">
                            <h2 className="mt-3">
                                Nuevo Producto
                            </h2>
                        </Col>
                    </Row>
                </Card>
            }

            <Row className="mt-2">
                <Col md={12}>
                    <Card className="p-4 shadow-sm">
                        <Row>
                            {/* Columna izquierda: Información del producto */}
                            <Col md={6}>
                                <h5 className="mb-3">Información del producto</h5>
                                <Form.Group className="mb-3">
                                    <Form.Label>Código de Barras:</Form.Label>

                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="text"
                                        name="vCodigoBarras"
                                        value={datos.vCodigoBarras} // Valor controlado por el estado
                                        onChange={handleChange}
                                    />


                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Nombre del Producto:</Form.Label>

                                    <Form.Control
                                        type="hidden"
                                    />
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        name="vNombreProducto"
                                        type="text"
                                        value={datos.vNombreProducto} // Valor controlado por el estado
                                        onChange={handleChange}
                                    />


                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo de Servicio:</Form.Label>

                                    <Form.Select
                                        value={servicio}
                                        onChange={(e) => {
                                            setServicio(e.target.value);
                                            // Actualizar dExistencia según el servicio seleccionado
                                            if (e.target.value === '1') {
                                                setDExistencia(0); // Si el servicio es '1', establecer dExistencia a 0
                                            } else {
                                                setDExistencia(datos ? datos.dExistencia : 0); // Restaurar el valor original
                                            }
                                        }}
                                    >

                                        <option value=''>Selecciona una opción</option>
                                        <option value="1">Servicio</option>
                                        <option value="0">Inventariada</option>
                                    </Form.Select>

                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Existencias de producto</Form.Label>

                                    {servicio === '' &&
                                        <Form.Control
                                            type="number"
                                            min="1"
                                            value={''}
                                            readOnly

                                        />
                                    }

                                    {servicio === '1' &&
                                        <Form.Control
                                            type="number"
                                            min="1"
                                            value={existencia}
                                            onChange={(e) => {
                                                setDExistencia(e.target.value);
                                            }}

                                            disabled
                                        />
                                    }
                                    {servicio === '0' &&

                                        <Form.Control
                                            type="number"
                                            min="1"
                                            value={existencia}
                                            onChange={(e) => {
                                                setDExistencia(e.target.value);
                                            }}
                                        />

                                    }



                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo de Factor IVA:</Form.Label>
                                    <Form.Select
                                        value={datos ? datos.vTipoFactorIVA : ""}
                                        onChange={(e) => {
                                            const nuevoTipoFactor = e.target.value;
                                            let nuevaTasaCuota = tasaCuotaIVA;

                                            // Actualizar el estado primero
                                            setDatos(prev => ({
                                                ...prev,
                                                vTipoFactorIVA: nuevoTipoFactor
                                            }));

                                            if (nuevoTipoFactor === 'Exento') {
                                                nuevaTasaCuota = 0;
                                                setTasaCuotaIVA(0);
                                            }
                                            if (nuevoTipoFactor === 'Cuota') {
                                                nuevaTasaCuota = 0;
                                                setTasaCuotaIVA(0);
                                            }
                                            if (nuevoTipoFactor === 'Tasa') {
                                                nuevaTasaCuota = 0;
                                                setTasaCuotaIVA(0);
                                            }

                                            calculaImpuestos(nuevoTipoFactor, datos.dTotal, nuevaTasaCuota);
                                            calcularRenovacionesDesdeTasaCuota(nuevoTipoFactor, nuevaTasaCuota);
                                        }}
                                    >
                                        <option value=''>Selecciona una opción</option>
                                        <option value='Exento'>Exento</option>
                                        <option value="Tasa">Tasa</option>
                                        <option value="Cuota">Cuota</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tasa o Cuota de IVA:</Form.Label>

                                    {datos.vTipoFactorIVA === '' &&
                                        <Form.Control
                                            type="number"
                                            step="1"
                                            min="1"
                                            max="100"


                                        />
                                    }
                                    {datos.vTipoFactorIVA === 'Exento' &&
                                        <Form.Control
                                            type="number"
                                            step="1"
                                            min="1"
                                            max="100"
                                            disabled
                                            value={tasaCuotaIVA}

                                        />
                                    }
                                    {datos.vTipoFactorIVA === 'Tasa' &&
                                        <Form.Control
                                            type="number"
                                            step="1"
                                            min="1"
                                            max="100"
                                            value={tasaCuotaIVA}
                                            pattern="^(0(\.\d{1,2})?|1(\.0{1,2})?)$"
                                            onInput={(e) => {
                                                let value = parseFloat(e.target.value);
                                                if (value > 1) {
                                                    e.target.value = tasaCuotaIVA; // Resetea al último valor válido
                                                    alert('La tasa debe tener un valor entre 0 y 1');
                                                }
                                            }}
                                            onChange={tasaCuota}
                                        />
                                    }
                                    {datos.vTipoFactorIVA === 'Cuota' &&
                                        <Form.Control
                                            type="number"
                                            step="1"
                                            min="1"
                                            max="100"
                                            value={tasaCuotaIVA}

                                            onInput={(e) => {
                                                let value = parseFloat(e.target.value);
                                                if (value > 1000) {
                                                    e.target.value = tasaCuotaIVA; // Resetea al último valor válido
                                                    alert('La cuota no puede ser mayor a 1000');
                                                }
                                            }}
                                            onChange={tasaCuota}
                                        />
                                    }

                                </Form.Group>

                                <div className="d-flex gap-2 align-items-start mb-5">
                                    <div className="flex-grow-1">
                                        <TextField
                                            id="vCodigoProductoSat"
                                            label="C&oacute;digo Producto o Servicio"
                                            size="small"
                                            value={datos.vCodigoProductoServicioSat || ''}
                                            onChange={(e) => {
                                                actualizarCodigoProd('vCodigoProductoServicioSat', e.target.value.trim());
                                            }}
                                            error={!validarCodigo.validadoCodigoSat}
                                            focused
                                            fullWidth
                                            disabled={validarCodigo.validandoCodigoSat}
                                            FormHelperTextProps={{ sx: { position: 'absolute', bottom: '-18px', whiteSpace: 'nowrap' } }}
                                            helperText={
                                                validarCodigo.validadoCodigoSat
                                                    ? claveDescripcion
                                                    : "Seleccione o valide un c&oacute;digo"
                                            }
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: validarCodigo.validadoCodigoSat
                                                            ? theme.palette.success.main
                                                            : theme.palette.error.main,
                                                    },
                                                },
                                                '& .MuiFormHelperText-root': {
                                                    color: validarCodigo.validadoCodigoSat
                                                        ? theme.palette.success.main
                                                        : theme.palette.error.main,
                                                },
                                            }}
                                            color={validarCodigo.validadoCodigoSat ? 'success' : 'error'}
                                        />
                                    </div>
                                    <Button
                                        variant="falcon-default"
                                        size="sm"
                                        className="mt-1"
                                        onClick={() => setShowBuscadorProducto(true)}
                                    >
                                        <FontAwesomeIcon icon="search" className="fs--2" />
                                    </Button>
                                </div>

                                <div className="d-flex gap-2 align-items-start mb-4">
                                    <div className="flex-grow-1">
                                        <TextField
                                            id="vClaveUnidadSat"
                                            label="Clave Unidad"
                                            size="small"
                                            value={datos.vClaveUnidadSat || ''}
                                            onChange={(e) => {
                                                actualizarClaveUnidad('vClaveUnidadSat', e.target.value.trim());
                                            }}
                                            error={!validarClave.validadoClaveUnidad}
                                            focused
                                            fullWidth
                                            disabled={validarClave.validandoClaveUnidad}
                                            FormHelperTextProps={{ sx: { position: 'absolute', bottom: '-18px', whiteSpace: 'nowrap' } }}
                                            helperText={
                                                validarClave.validadoClaveUnidad
                                                    ? "Clave v&aacute;lida"
                                                    : "Seleccione o valide una clave"
                                            }
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: validarClave.validadoClaveUnidad
                                                            ? theme.palette.success.main
                                                            : theme.palette.error.main,
                                                    },
                                                },
                                                '& .MuiFormHelperText-root': {
                                                    color: validarClave.validadoClaveUnidad
                                                        ? theme.palette.success.main
                                                        : theme.palette.error.main,
                                                },
                                            }}
                                            color={validarClave.validadoClaveUnidad ? 'success' : 'error'}
                                        />
                                    </div>
                                    <Button
                                        variant="falcon-default"
                                        size="sm"
                                        className="mt-1"
                                        onClick={() => setShowBuscadorUnidad(true)}
                                    >
                                        <FontAwesomeIcon icon="search" className="fs--2" />
                                    </Button>
                                </div>

                            </Col>




                            {/* Columna derecha: Precio del producto */}
                            <Col md={6}>
                                <h5 className="mb-3">Precio del producto</h5>

                                <Form.Group className="mb-3">
                                    <Form.Label>Disponibilidad:</Form.Label>
                                    <Form.Select
                                        value={esActivo}
                                        onChange={(e) => {
                                            setEsActivo(e.target.value);
                                        }}

                                    >
                                        <option value=''>Selecciona la disponibilidad</option>
                                        <option value="1">Disponible</option>
                                        <option value="0">No disponible</option>
                                    </Form.Select>


                                </Form.Group>

                                {/* 🆕 Selector de Moneda */}
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        <i className="bi bi-currency-exchange me-2"></i>
                                        Moneda:
                                    </Form.Label>
                                    <Form.Select
                                        value={datos.vMoneda}
                                        name="vMoneda"
                                        onChange={(e) => setDatos(prev => ({ ...prev, vMoneda: e.target.value }))}
                                    >
                                        <option value="MXN">🇲🇽 MXN - Pesos Mexicanos</option>
                                        <option value="USD">🇺🇸 USD - Dólares Estadounidenses</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo Pago:</Form.Label>
                                    <Form.Select
                                        value={datos.iTipoPago}
                                        name="iTipoPago"
                                        onChange={handleChangeTipoPrecio}
                                    >
                                        <option value=''>Selecciona un tipo de pago</option>
                                        <option value='1'>Pago único</option>
                                        <option value='2'>Renovación</option>
                                    </Form.Select>
                                </Form.Group>

                                {datos.iTipoPago == '1' && (
                                    <div>
                                        {/* -- Precio Final -- */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <i className="bi bi-cash-stack me-2"></i>
                                                Precio Final ({datos.vMoneda}):
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                step="0.01"
                                                defaultValue={datos ? datos.dTotal : ""}

                                                onChange={(e) => calculaImpuestos(datos.vTipoFactorIVA, e.target.value, datos.dTasaCuotaIVA)}
                                            />

                                        </Form.Group>

                                        {/* -- Precio Base -- */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Precio Base ({datos.vMoneda}):</Form.Label>
                                            <Form.Control
                                                value={datos ? `$${parseFloat(datos.dPrecioUnitario).toLocaleString("es-MX", { maximumFractionDigits: 6, minimumFractionDigits: 2 })}` : ""}
                                                disabled // Lo calculamos automáticamente

                                            />

                                        </Form.Group>

                                        {/* -- IVA calculado -- */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>IVA ({datos.vMoneda}):</Form.Label>
                                            <Form.Label></Form.Label>
                                            <Form.Control
                                                value={datos ? `$${parseFloat(datos.dIVA).toLocaleString("es-MX", { maximumFractionDigits: 6, minimumFractionDigits: 2 })}` : ""}
                                                disabled

                                            />

                                        </Form.Group>
                                    </div>
                                )}

                                {datos.iTipoPago == '2' && (
                                    <div className="mb-3 ps-3 border-start border-2 border-secondary">
                                        <Form.Label className="fw-semibold">
                                            Selecciona los tipos de Renovación para este producto
                                        </Form.Label>

                                        {datos.renovaciones.map(({ tipo, activo, total, priceId }) => (
                                                    <div key={tipo} className="mb-3 p-2 border rounded">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label={tipo.charAt(0).toUpperCase() + tipo.slice(1)}
                                                            checked={activo}
                                                            onChange={() => handleCheckboxChange(tipo)}
                                                        />
                                                        {activo && (
                                                            <>
                                                                <div className="input-group mt-2">
                                                                    <span className="input-group-text">
                                                                        <i className="bi bi-currency-dollar me-1"></i>
                                                                        {datos.vMoneda}
                                                                    </span>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder={`Precio ${tipo}`}
                                                                        value={total}
                                                                        onChange={(e) => handlePrecioChange(tipo, e.target.value)}
                                                                    />
                                                                </div>
                                                                {/* Mostrar Price ID si NO es un producto nuevo */}
                                                                {!nuevoProducto && priceId && (
                                                                    <div className="mt-2">
                                                                        <Form.Label className="small text-muted mb-1">
                                                                            <i className="bi bi-tag me-1"></i>
                                                                            Price ID:
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={priceId}
                                                                            readOnly
                                                                            disabled
                                                                            className="bg-light"
                                                                            size="sm"
                                                                        />
                                                                        <Form.Text className="text-muted">
                                                                            <small>Este ID fue generado automáticamente</small>
                                                                        </Form.Text>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                        {activo && total !== '' && (
                                                            <>
                                                                <div className="text-muted mt-1" style={{ fontSize: '0.85rem' }}>
                                                                    Precio Base: ${datos.renovaciones.find(r => r.tipo === tipo)?.preciounitario || '0.00'}
                                                                </div>
                                                                <div className="text-muted" style={{ fontSize: '0.85rem' }}>
                                                                    IVA: ${datos.renovaciones.find(r => r.tipo === tipo)?.iva || '0.00'}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                ))}
                                    </div>
                                )}

                                <Form.Group className="mb-3">
                                    <Form.Label>Comision:</Form.Label>

                                    <Form.Select
                                        value={datos.idCatDepartamento}

                                        name="idCatDepartamento"
                                        onChange={handleChange}
                                    >
                                        <option value=''>Selecciona una comision</option>
                                        <option value='0'> No Comision</option>
                                        <option value='1'>Comision</option>
                                        <option value='2'>Comision Parcial 30%</option>
                                    </Form.Select>


                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo Producto:</Form.Label>

                                    <Form.Select
                                        value={datos.vTipoProducto}
                                        onChange={handleChangeTipoProducto}
                                        name="vTipoProducto"
                                    >
                                        <option value=''>Selecciona el tipo de producto</option>
                                        <option value='Licencia'> Licencia</option>
                                        <option value='ModuloExtra'> Módulo Extra</option>
                                        <option value='Paquete'> Paquete de Módulos</option>
                                        <option value='UsuarioAkasiaPOS'> Usuario Akasia POS</option>
                                        <option value='Otro'> Otro</option>
                                    </Form.Select>


                                </Form.Group>

                                {/* Tipo de Licencia - Solo visible si el tipo de producto es "Licencia" */}
                                {datos.vTipoProducto === 'Licencia' && (
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            <i className="bi bi-key me-2"></i>
                                            Tipo de Licencia:
                                        </Form.Label>
                                        <Form.Select
                                            value={datos.idCatTipoLicencia || ''}
                                            name="idCatTipoLicencia"
                                            onChange={(e) => setDatos(prev => ({ ...prev, idCatTipoLicencia: e.target.value ? parseInt(e.target.value) : null }))}
                                        >
                                            <option value=''>Selecciona un tipo de licencia</option>
                                            {tiposLicencia.map((tipo) => (
                                                <option key={tipo.idCatTipoLicencia} value={tipo.idCatTipoLicencia}>
                                                    {tipo.vDescripcionTipo}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Text className="text-muted">
                                            <small>Este campo es obligatorio para productos tipo Licencia</small>
                                        </Form.Text>
                                    </Form.Group>
                                )}

                                {/* 🆕 NUEVO: Dropdown para Canal del Producto*/}
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        <i className="bi bi-shop me-2"></i>
                                        Canal del Producto:
                                    </Form.Label>
                                    <Form.Select
                                        value={datos.iCanalProducto}
                                        name="iCanalProducto"
                                        onChange={(e) => setDatos(prev => ({ ...prev, iCanalProducto: e.target.value }))}
                                    >
                                        <option value="0">Producto General</option>
                                        <option value="1">Licencia de AkasiaPOS</option>
                                        <option value="2">Licencia Nube (Desktop)</option>
                                    </Form.Select>
                                    <Form.Text className="text-muted">
                                        <small>Identifica el canal o contexto donde el producto es utilizado o mostrado</small>
                                    </Form.Text>
                                    {/* Leyenda condicional y más estética */}
                                    {datos.iCanalProducto === "2" && (
                                        <div className="mt-3 p-3 rounded border bg-white shadow-sm" style={{ fontSize: '0.95rem', lineHeight: 1.35 }}>
                                            <div className="d-flex align-items-start gap-2">
                                                <div className="text-primary" style={{ fontSize: '1.25rem' }}>
                                                    <i className="bi bi-display-fill"></i>
                                                </div>
                                                <div>
                                                    <div style={{ fontWeight: 700, marginBottom: 6 }}>Desktop</div>
                                                    <div className="text-muted">Si eliges esta opción, el producto aparecerá en la aplicación Desktop. Será necesario programar la ventana de marketing para mostrarlo en la interfaz del Desktop.</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {datos.iCanalProducto === "1" && (
                                        <div className="mt-3 p-3 rounded border bg-white shadow-sm" style={{ fontSize: '0.95rem', lineHeight: 1.35 }}>
                                            <div className="d-flex align-items-start gap-2">
                                                <div className="text-success" style={{ fontSize: '1.25rem' }}>
                                                    <i className="bi bi-cart-fill"></i>
                                                </div>
                                                <div>
                                                    <div style={{ fontWeight: 700, marginBottom: 6 }}>AkasiaPOS</div>
                                                    <div className="text-muted">Si eliges esta opción, el producto estará disponible en la sección de compra de planes dentro de AkasiaPOS. Requiere programar la integración para que los usuarios puedan adquirirlo desde la app.</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Form.Group>
                            </Col>
                            {/* Input de imagen estilo Falcon */}
                            <Col className="mb-4">
                                <div
                                    className={`border-dashed rounded-3 p-4 text-center ${arrastrarImagen ? 'bg-primary-soft' : 'bg-light'
                                        }`}
                                    onDragEnter={handleDrag}
                                    onDragLeave={handleDrag}
                                    onDragOver={handleDrag}
                                    onDrop={handleDrop}
                                >
                                    <input
                                        type="file"
                                        id="imagenProducto"
                                        onChange={seleccionarImagen}
                                        accept="image/*"
                                        className="d-none"
                                    />

                                    <label
                                        htmlFor="imagenProducto"
                                        className="btn btn-outline-primary mb-3"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <i className="bi bi-cloud-upload me-2"></i>
                                        {arrastrarImagen ? 'Suelta la imagen aquí' : 'Seleccionar imagen'}
                                    </label>

                                    <p className="small text-muted mb-0">
                                        Arrastra y suelta tu imagen aquí <br />
                                        Formatos aceptados: JPG, PNG (Máx. 2MB)
                                    </p>

                                    {/* Vista previa del nombre del archivo */}
                                    {(datos.vImagenProducto_Name || imagenProducto.fileName) && (
                                        <div className="mt-3 d-flex align-items-center justify-content-center">
                                            <div className="text-success small me-2">
                                                <i className="bi bi-check-circle-fill me-2"></i>
                                                {datos.vImagenProducto_Name || imagenProducto.fileName}
                                            </div>
                                            {/* Botón para borrar la imagen */}
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={borrarImagen}
                                                style={{ padding: '0.25rem 0.5rem' }}
                                            >
                                                <i className="bi bi-trash"></i>
                                                <h7>Borrar</h7>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>


                        <Row className="mt-4">
                            <Col className="d-flex justify-content-end">
                                <Link to="/productos/Catalogo">
                                    {
                                        guardando ?
                                            <Button
                                                variant="danger"
                                                className="me-2"
                                                disabled
                                            >
                                                Descartar
                                            </Button>
                                            :
                                            <Button
                                                variant="danger"
                                                className="me-2"
                                            >
                                                Descartar
                                            </Button>
                                    }
                                </Link>

                                {
                                    guardando ?
                                        <>
                                            <Button
                                                variant="primary"
                                                disabled
                                                onClick={() => guardarProductos()}

                                            >
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                {datos.iTipoPago === "2" && nuevoProducto
                                                    ? 'Creando en Stripe y guardando...'
                                                    : 'Guardando Producto...'}
                                            </Button>

                                        </>
                                        :
                                        <>

                                            <Button
                                                variant="primary"
                                                disabled={
                                                    datos.vCodigoBarras === "" ||
                                                    datos.vNombreProducto === "" ||
                                                    datos.idCatDepartamento === '' ||
                                                    datos.vClaveUnidadSat === '' ||
                                                    datos.vCodigoProductoServicioSat === '' ||
                                                    existencia === '' ||
                                                    esActivo === '' ||
                                                    datos.vTipoFactorIVA === '' ||
                                                    datos.iTipoPago === "" ||
                                                    datos.vTipoProducto === "" ||
                                                    datos.iCanalProducto === "" ||
                                                    (datos.vTipoProducto === "Licencia" && !datos.idCatTipoLicencia) ||
                                                    (datos.iTipoPago === "1" && (datos.dTotal === '' || datos.dTotal <= 0)) ||
                                                    (datos.iTipoPago === "2" && (
                                                        datos.renovaciones.filter(r => r.activo && r.total && parseFloat(r.total) > 0).length === 0
                                                    ))
                                                }

                                                onClick={() => guardarProductos()}

                                            >
                                                <i className="bi bi-save me-2"></i>
                                                Guardar Producto
                                            </Button>

                                        </>
                                }
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <BuscadorSatModal
                show={showBuscadorProducto}
                onHide={() => setShowBuscadorProducto(false)}
                onSelect={(item) => {
                    actualizarCodigoProd('vCodigoProductoServicioSat', item.codigo);
                    setClaveDescripcion(item.descripcion);
                    setValidarCodigo({
                        validadoCodigoSat: true,
                        validandoCodigoSat: false
                    });
                    setShowBuscadorProducto(false);
                }}
                tipo="producto"
            />

            <BuscadorSatModal
                show={showBuscadorUnidad}
                onHide={() => setShowBuscadorUnidad(false)}
                onSelect={(item) => {
                    actualizarClaveUnidad('vClaveUnidadSat', item.codigo);
                    setValidarClave({
                        validadoClaveUnidad: true,
                        validandoClaveUnidad: false
                    });
                    setShowBuscadorUnidad(false);
                }}spr_AdminPanel_Producto_CatalogoProducto
                tipo="unidad"
            />
        </>
    );
};

AgregarProducto.propTypes = {
    productos: PropTypes.object,
    renovaciones: PropTypes.array
};

export default AgregarProducto;
